import React, { Component } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	CardFooter,
	FormGroup,
	Label,
	Input,
	Row,
	Col,
	Table,
	// Modal,
	// ModalHeader,
	// ModalBody,
	Spinner,
	InputGroup,
	InputGroupAddon,
	CustomInput,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import SimpleBar from "simplebar-react";

import Swal from "sweetalert2";
import moment from "moment";
import TableScrollbar from "react-table-scrollbar";

import "./NewInGatePass.scss";
import { getMiniVendors, getUserLocations } from "../../../store/Mini/actions";
import {
	SelecteChangeValue,
	getPOList,
	AddPOdata,
	InputChangeValue,
	IgpInputChangeValue,
	IGPAdd,
	IGPItemSelect,
	getPOItemsList,
	ItemQtyChangeValue,
	ItemUnitsChangeValue,
	SetParams,
	IGPPODataRemove,
	IGPImageUpload,
} from "../../../store/ingatepass/actions";
import POItemsModel from "./poItemsModel";
import LoadingModel from "../../LoadingModel";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";

class NewInGatePass extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedItems: {},
			vehicleImagePreviewUrl: null,
			personImagePreviewUrl: null,
		};
		this.ChangeHandeler = this.ChangeHandeler.bind(this);

		this.tog_static = this.tog_static.bind(this);
		// this.handleValidSubmit = this.handleValidSubmit.bind(this);
	}

	tog_static(PoId) {
		this.setState((prevState) => ({
			modal_static: !prevState.modal_static,
		}));

		this.removeBodyCss();
	}
	removeBodyCss() {
		document.body.classList.add("no_padding");
	}

	componentDidMount() {
		this.props.getMiniVendors();
		this.props.getUserLocations();
		this.props.getPOList();
	}

	ChangeHandeler(e) {
		this.props.IgpInputChangeValue({
			key: e.target.name,
			value: e.target.value,
		});
	}

	handleSearch = (e) => {
		if (e.key === "Enter") {
			this.props.getPOList({
				...this.props.params,
				page: 1,
				search: e.target.value,
			});
		}
	};
	SearchHandle = (e) => {
		this.props.SetParams({
			...this.props.params,
			search: e.target.value,
			page: 1,
		});
		if (e.target.value === "") {
			this.props.getPOList({
				...this.props.params,
				page: 1,
				search: "",
			});
		}
	};
	getPOItems(id) {
		this.props.getPOItemsList(id);
	}
	RemoveIGPItem(item) {
		Swal.fire({
			title: "Are you sure?",
			text: "You won't be able to revert this!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, delete it!",
		}).then((result) => {
			if (result.isConfirmed) {
				this.props.IGPPODataRemove(item);
				this.props.getPOList();
			}
		});
	}

	handleValidSubmit() {
		if (this.props.IGPPOData.length !== 0) {
			var Mgrn2items = [];
			var grn2poitems = this.props.IGPPOData.map((po) => {
				var grn2items = po.grn2items.map((p) => {
					return {
						// id: p.id,
						purchaseorder_id: po.purchaseorder_id,
						product_id: p.product.id,
						qty: p.t_qty ? p.t_qty : p.availableqty,
						unit_id: p.t_unit
							? p.t_unit.id
							: p.product?.baseunit.id,
						tax_id: p.tax.id,
						taxtype: p.taxtype,
						poitem_id: p.id,
						// price:
						// gross:
						make: "",
						description: "",
						dodelete: p.dodelete,
					};
				});
				Mgrn2items.push(...grn2items);
				return {
					purchaseorder_id: po.purchaseorder_id,
					description: po.description,
					vendor_id: po.vendor_id,
					bill_image_id: po.bill_image_id,
				};
			});
			var data = {
				location_id: this.props.userLocation[0].id,
				description: this.props.IGPRowData.description,
				vehicleno: this.props.IGPRowData.vehicleno,
				personname: this.props.IGPRowData.personname,
				user_image_id: this.props.personImage.id,
				vehicle_image_id: this.props.vehicleImage.id,
				grn2pos: grn2poitems,
				grn2items: Mgrn2items,
			};
			if (
				data.user_image_id !== null &&
				data.user_image_id !== undefined
			) {
				if (
					data.vehicle_image_id !== null &&
					data.vehicle_image_id !== undefined
				) {
					this.props.IGPAdd(
						data,
						this.props.match.params.id,
						this.props.history
					);
				} else {
					Swal.fire({
						icon: "error",
						title: "Please upload Vehicle Image ",
					});
				}
			} else {
				Swal.fire({
					icon: "error",
					title: "Please upload Person Image ",
				});
			}
		} else {
			Swal.fire({
				icon: "error",
				title: "Please Select The PO's",
			});
		}
	}
	handleVehicleImageChange(e) {
		e.preventDefault();

		let reader = new FileReader();
		let file = e.target.files[0];
		// var url = reader.readAsDataURL(file);
		this.props.IGPImageUpload(e.target.files[0], "vehicle");
		reader.onloadend = () => {
			this.setState({
				vehicleImagePreviewUrl: reader.result,
				// POBillImgFile: file,
			});
		};
		if (e.target.files.length !== 0) {
			reader.readAsDataURL(file);
		} else {
			// this.props.PreviewImage({});

			this.setState({
				vehicleImagePreviewUrl: null,
				// POBillImgFile: null,
			});
		}
	}
	handlePersonImageChange(e) {
		e.preventDefault();

		let reader = new FileReader();
		let file = e.target.files[0];
		// var url = reader.readAsDataURL(file);
		this.props.IGPImageUpload(e.target.files[0], "person");

		reader.onloadend = () => {
			this.setState({
				personImagePreviewUrl: reader.result,
				// POBillImgFile: file,
			});
		};
		if (e.target.files.length !== 0) {
			reader.readAsDataURL(file);
		} else {
			// this.props.PreviewImage({});

			this.setState({
				personImagePreviewUrl: null,
				// POBillImgFile: null,
			});
		}
	}
	//----------------------

	render() {
		let { vehicleImagePreviewUrl } = this.state;
		let $vehicleimagePreview = null;
		let { personImagePreviewUrl } = this.state;
		let $personImagePreview = null;

		if (vehicleImagePreviewUrl) {
			$vehicleimagePreview = (
				<img
					className="product-img"
					alt="User"
					src={vehicleImagePreviewUrl}
					style={{
						height: "150px",
						width: "250px",
						cursor: "pointer",
					}}
				/>
			);
		} else if (this.props.PORowData?.bill_image) {
			$vehicleimagePreview = (
				<img
					className="product-img"
					alt="User"
					src={
						this.props.PORowData?.bill_image
							? this.props.PORowData?.bill_image
							: DefaultImg
					}
					style={{
						height: "150px",
						width: "250px",
						cursor: "pointer",
					}}
				/>
			);
		} else {
			$vehicleimagePreview = (
				<div
					className="img-thumbnail text-center W-100 pt-2 "
					style={{
						height: "150px",
						width: "250px",
						cursor: "pointer",
					}}>
					<i className="ri-upload-cloud-line ri-4x"></i>
					<br />
					<span className="font-size-16">Select Vehicle Image</span>
				</div>
			);
		}
		if (personImagePreviewUrl) {
			$personImagePreview = (
				<img
					className="product-img"
					alt="User"
					src={personImagePreviewUrl}
					style={{
						height: "150px",
						width: "250px",
						cursor: "pointer",
					}}
				/>
			);
		} else if (this.props.PORowData?.bill_image) {
			$personImagePreview = (
				<img
					className="product-img"
					alt="User"
					src={
						this.props.PORowData?.bill_image
							? this.props.PORowData?.bill_image
							: DefaultImg
					}
					style={{
						height: "150px",
						width: "250px",
						cursor: "pointer",
					}}
				/>
			);
		} else {
			$personImagePreview = (
				<div
					className="img-thumbnail text-center W-100 pt-2 "
					style={{
						height: "150px",
						width: "250px",
						cursor: "pointer",
					}}>
					<i className="ri-upload-cloud-line ri-4x"></i>
					<br />
					<span className="font-size-16">Select Person Image</span>
				</div>
			);
		}
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						{this.props.loading && (
							<LoadingModel OpenModel={this.props.loading} />
						)}

						<AvForm
							className="needs-validation"
							onValidSubmit={() => {
								this.handleValidSubmit();
							}}>
							<Row>
								<Col md={12} className="p-1 W-100">
									<Card className="p-0 ">
										<CardHeader className="bg-transparent border-bottom ">
											<Link
												to="/igpdashboard"
												className="action-icon text-primary mr-2">
												<i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
											</Link>
											<h5 className="card-title-18 pt-2 d-inline-block">
												New IGP456
											</h5>
										</CardHeader>
										<CardBody className="p-2 ">
											<Row>
												<Col md={3}>
													<Card className="pt-1">
														<CardBody className="p-0">
															<div>
																<FormGroup className="m-0 pb-0">
																	<InputGroup>
																		<Input
																			type="text"
																			name="search"
																			className="form-control d-inline-block"
																			placeholder="Search"
																			validate={{
																				required: true,
																			}}
																			onChange={(
																				e
																			) =>
																				this.SearchHandle(
																					e
																				)
																			}
																			onKeyDown={(
																				e
																			) =>
																				this.handleSearch(
																					e
																				)
																			}
																		/>
																		<InputGroupAddon addonType="append">
																			<Button
																				color="light"
																				type="submit"
																				onClick={() =>
																					this.props.getPOList(
																						{
																							...this
																								.props
																								.params,
																							page: 1,
																						}
																					)
																				}>
																				<i className="ri-search-line"></i>
																			</Button>
																		</InputGroupAddon>
																	</InputGroup>
																</FormGroup>
															</div>
															<SimpleBar
																style={{
																	height: "85vh",
																}}>
																<div
																	id="Items-menu"
																	className="pl-2 pr-2">
																	<ul
																		className="metismenu list-unstyled"
																		id="Items-menu">
																		{this
																			.props
																			.poList
																			.length ===
																		0 ? (
																			<>
																				{this
																					.props
																					.loading ? (
																					<div className="text-center">
																						<Spinner color="primary" />
																					</div>
																				) : (
																					<div className="text-center">
																						<span className="font-size-18 text-danger">
																							PO
																							Data
																							not
																							available
																						</span>
																					</div>
																				)}
																			</>
																		) : (
																			<>
																				{this.props.poList.map(
																					(
																						item,
																						i
																					) => (
																						<>
																							<li>
																								<Link
																									to="#"
																									onClick={() => {
																										this.getPOItems(
																											item.id
																										);
																									}}
																									className={
																										item.id ===
																										this
																											.props
																											.itemSelectedId
																											? "waves-effect Item-active"
																											: "waves-effect"
																									}
																									id={
																										item.code
																									}>
																									<span>
																										<span
																											style={
																												item.postatus ===
																												2
																													? {
																															color: "#5664d2",
																													  }
																													: {
																															color: "#f77d00",
																													  }
																											}>
																											PO
																											Code:{" "}
																										</span>
																										<b
																											style={
																												item.postatus ===
																												2
																													? {
																															color: "#5664d2",
																													  }
																													: {
																															color: "#f77d00",
																													  }
																											}>
																											{
																												item.code
																											}{" "}
																										</b>
																									</span>
																									<br />
																									<span>
																										<span
																											style={{
																												color: "#74788d",
																											}}>
																											{" "}
																											PO
																											Date:
																										</span>{" "}
																										<b>
																											{moment(
																												item.createdon
																											).format(
																												"DD-MM-YYYY"
																											)}
																										</b>
																									</span>
																									<br />
																									<span>
																										<span
																											style={{
																												color: "#74788d",
																											}}>
																											PO
																											Items:
																										</span>{" "}
																										<b>
																											{
																												item.items_count
																											}{" "}
																											Items
																										</b>
																									</span>
																									<br />
																									<span>
																										<span
																											style={{
																												color: "#74788d",
																											}}>
																											Vendor
																											Name:
																										</span>{" "}
																										<b>
																											{
																												item
																													.vendor
																													?.name
																											}
																										</b>
																									</span>
																								</Link>
																							</li>
																						</>
																					)
																				)}
																			</>
																		)}
																	</ul>
																</div>
															</SimpleBar>
														</CardBody>
													</Card>
												</Col>
												<Col md={9}>
													<Card className="pt-1">
														<CardBody className="p-0">
															<Row>
																<Col md={6}>
																	<FormGroup
																		row>
																		<Col
																			md={
																				3
																			}>
																			<Label
																				htmlFor="vehicle"
																				className="col-form-label ">
																				Vehicle
																				Number
																				:
																			</Label>
																		</Col>
																		<Col
																			md={
																				9
																			}>
																			<AvField
																				name="vehicleno"
																				type="text"
																				value={
																					this
																						.props
																						.IGPRowData
																						.vehicleno ==
																					null
																						? ""
																						: this
																								.props
																								.IGPRowData
																								.vehicleno
																				}
																				onChange={
																					this
																						.ChangeHandeler
																				}
																				className="form-control"
																				id="vehicleno"
																				placeholder="Enter Vehicle Number"
																				errormessage=" Please provide a valid text"
																				validate={{
																					required:
																						{
																							value: true,
																						},
																				}}
																			/>
																		</Col>
																	</FormGroup>
																</Col>
																<Col md={6}>
																	<FormGroup
																		row>
																		<Col
																			md={
																				3
																			}>
																			<Label
																				htmlFor="contactperson"
																				className="col-form-label ">
																				Contact
																				Person
																				:
																			</Label>
																		</Col>
																		<Col
																			md={
																				9
																			}>
																			<AvField
																				name="personname"
																				type="text"
																				value={
																					this
																						.props
																						.IGPRowData
																						.personname ==
																					null
																						? ""
																						: this
																								.props
																								.IGPRowData
																								.personname
																				}
																				onChange={
																					this
																						.ChangeHandeler
																				}
																				className="form-control"
																				id="personname"
																				placeholder="Enter contact person"
																				errormessage=" Please provide a valid text"
																				validate={{
																					required:
																						{
																							value: true,
																						},
																				}}
																			/>
																		</Col>
																	</FormGroup>
																</Col>
															</Row>
															<div className="table-responsive m-1">
																<TableScrollbar height="400px">
																	<Table className="mb-0 p-1 table-centered">
																		<thead className="bg-light text-center">
																			<tr>
																				<th className="">
																					S.No
																				</th>
																				<th className="">
																					PO
																					Code
																				</th>
																				<th className="">
																					PO
																					Items
																				</th>
																				<th>
																					Vendor
																					Name
																				</th>
																				<th>
																					Action
																				</th>
																			</tr>
																		</thead>
																		<tbody>
																			{this
																				.props
																				.IGPPOData
																				.length !==
																			0 ? (
																				<>
																					{this.props.IGPPOData?.map(
																						(
																							po,
																							key
																						) => (
																							<>
																								{!po.dodelete && (
																									<tr
																										key={
																											key
																										}>
																										<td className="text-center">
																											{key +
																												1}
																										</td>
																										<td className="nowrap text-center">
																											<Link
																												to="#"
																												onClick={() =>
																													this.getPOItems(
																														po.purchaseorder_id
																													)
																												}
																												className="text-dark">
																												{
																													po.purchaseorder_code
																												}
																											</Link>
																										</td>
																										<td className="nowrap text-center">
																											{
																												po
																													.grn2items
																													.length
																											}
																										</td>

																										<td className="nowrap text-center">
																											{
																												po.Vendor_name
																											}
																										</td>
																										<td className="nowrap text-center">
																											<Button
																												type="button"
																												color="primary"
																												className="waves-effect waves-light"
																												onClick={() => {
																													this.getPOItems(
																														po.purchaseorder_id
																													);
																												}}>
																												<i className="mdi mdi-grease-pencil"></i>
																											</Button>
																											<Button
																												type="button"
																												color="danger"
																												className="ml-2 waves-effect waves-light"
																												onClick={() => {
																													this.RemoveIGPItem(
																														po
																													);
																												}}>
																												<i className="mdi mdi-delete"></i>
																											</Button>
																										</td>
																									</tr>
																								)}
																							</>
																						)
																					)}
																				</>
																			) : (
																				<tr>
																					<td
																						colSpan={
																							9
																						}
																						className="text-center">
																						<div>
																							<span className="font-size-18 text-danger">
																								Data
																								not
																								available
																							</span>
																						</div>
																					</td>
																				</tr>
																			)}
																		</tbody>
																	</Table>
																</TableScrollbar>
															</div>
														</CardBody>
													</Card>
													<Row>
														<Col md={6}>
															<Card className="p-0 ">
																<CardHeader className="bg-transparent border-bottom p-1">
																	<i className="mdi mdi-alert-circle-outline ml-2 mr-2 font-size-20"></i>

																	<h5 className="card-title-15 d-inline-block">
																		Other
																		Details
																	</h5>
																</CardHeader>
																<CardBody className="p-2 ">
																	<div>
																		<FormGroup className="mb-0">
																			<AvField
																				name="description"
																				id="description"
																				type="textarea"
																				className="form-control"
																				placeholder="Enter Details"
																				value={
																					this
																						.props
																						.IGPRowData
																						.description ==
																					null
																						? ""
																						: this
																								.props
																								.IGPRowData
																								.description
																				}
																				rows="7"
																				onChange={
																					this
																						.ChangeHandeler
																				}
																			/>
																		</FormGroup>
																	</div>
																</CardBody>
															</Card>
														</Col>
														<Col md={6}>
															<Card className="p-0 ">
																<CardHeader className="bg-transparent border-bottom p-1">
																	<Row>
																		<Col
																			md={
																				6
																			}>
																			<h5 className="card-title-15 d-inline-block">
																				Vehicle
																				Image
																			</h5>
																		</Col>
																		<Col
																			md={
																				6
																			}>
																			<h5 className="card-title-15 d-inline-block">
																				Person
																				Image
																			</h5>
																		</Col>
																	</Row>
																</CardHeader>
																<CardBody className="p-2 ">
																	<Row>
																		<Col
																			md={
																				6
																			}>
																			<div className="product-detail">
																				<div className="mt-2 align-items-center ">
																					<label htmlFor="VehicleCustomFile">
																						{
																							$vehicleimagePreview
																						}
																					</label>
																					<span className="text-danger mt-0">
																						{
																							this
																								.props
																								.error_msg
																								?.image
																						}
																					</span>
																					<div
																						className="d-inline-block"
																						style={{
																							width: "250px",
																						}}>
																						<CustomInput
																							type="file"
																							className="file-upload"
																							id="VehicleCustomFile"
																							accept="image/*"
																							multiple={
																								false
																							}
																							onChange={(
																								e
																							) =>
																								this.handleVehicleImageChange(
																									e
																								)
																							}
																							required
																							validate={{
																								required:
																									{
																										value: true,
																									},
																								// pattern: { value: "^[A-Za-z0-9]+$" },
																								// minLength: { value: 6 },
																								// maxLength: { value: 16 },
																							}}
																						/>
																					</div>
																				</div>
																			</div>
																		</Col>
																		<Col
																			md={
																				6
																			}>
																			<div className="product-detail">
																				<div className="mt-2 align-items-center ">
																					<label htmlFor="PersonCustomFile">
																						{
																							$personImagePreview
																						}
																					</label>
																					<span className="text-danger mt-0">
																						{
																							this
																								.props
																								.error_msg
																								?.image
																						}
																					</span>
																					<div
																						className="d-inline-block"
																						style={{
																							width: "250px",
																						}}>
																						<CustomInput
																							type="file"
																							className="file-upload"
																							id="PersonCustomFile"
																							accept="image/*"
																							multiple={
																								false
																							}
																							onChange={(
																								e
																							) =>
																								this.handlePersonImageChange(
																									e
																								)
																							}
																							required
																							validate={{
																								required:
																									{
																										value: true,
																									},
																								// pattern: { value: "^[A-Za-z0-9]+$" },
																								// minLength: { value: 6 },
																								// maxLength: { value: 16 },
																							}}
																						/>
																					</div>
																				</div>
																			</div>
																		</Col>
																	</Row>
																</CardBody>
															</Card>
														</Col>
													</Row>
												</Col>
											</Row>

											<CardFooter className="bg-transparent p-1">
												<div className="float-right">
													<Button
														type="reset"
														color="light"
														className="waves-effect waves-light mr-2"
														href="/QuotationDashboard">
														Cancel
													</Button>
													<Button
														type="submit"
														color="primary"
														className="waves-effect waves-light"
														disabled={
															this.props.loading
														}
														// onClick={() => this.handleValidSubmit()}
													>
														Submit
													</Button>
												</div>
											</CardFooter>
										</CardBody>
									</Card>
								</Col>
							</Row>
						</AvForm>
					</Container>
					<POItemsModel />
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { vendorslist, vendorsLoading, vendorParams, userLocation } =
		state.Mini;
	const {
		IGPRowData,
		poList,
		PORowData,
		igpitems,
		poData,
		poItemsList,
		itemSelectedId,
		params,
		filterPOData,
		IGPPOData,
		loading,
		vehicleImage,
		personImage,
	} = state.ingatepass;

	return {
		vendorslist,
		vendorsLoading,
		vendorParams,
		userLocation,
		IGPRowData,
		poList,
		PORowData,
		igpitems,
		poData,
		poItemsList,
		itemSelectedId,
		params,
		filterPOData,
		IGPPOData,
		loading,
		vehicleImage,
		personImage,
	};
};

export default connect(mapStatetoProps, {
	getMiniVendors,
	SelecteChangeValue,
	IgpInputChangeValue,
	getPOList,
	AddPOdata,
	InputChangeValue,
	IGPAdd,
	getUserLocations,
	IGPItemSelect,
	getPOItemsList,
	ItemQtyChangeValue,
	ItemUnitsChangeValue,
	SetParams,
	IGPPODataRemove,
	IGPImageUpload,
})(NewInGatePass);
